// extracted by mini-css-extract-plugin
export var askAiIcon = "_kn-9";
export var container = "_kn-0";
export var groupSeparator = "_kn-a";
export var highlight = "_kn-4";
export var resultIcon = "_kn-5";
export var resultItem = "_kn-7";
export var resultSubtitle = "_kn-3";
export var resultTitle = "_kn-2";
export var resultsList = "_kn-1";
export var searchGroup = "_kn-6";
export var selected = "_kn-8";